import { STORE_INQUIRIES, UPDATE_INQUIRY_STATUS } from '../actions/types';

const initialState = {
    inquiries: [],
};

const inquiriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case STORE_INQUIRIES:
            return { ...state, inquiries: action.payload };
        case UPDATE_INQUIRY_STATUS: {
            const { inquiryId, status } = action.payload;
            return {
                ...state,
                inquiries: state.inquiries.map(i =>
                    i.id === inquiryId ? { ...i, status } : i
                ),
            };
        }
        default:
            return state;
    }
};

export default inquiriesReducer;
